import { render, staticRenderFns } from "./mortgage-estimate-approved.vue?vue&type=template&id=5649bd81"
import script from "./mortgage-estimate-approved.vue?vue&type=script&lang=js"
export * from "./mortgage-estimate-approved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports